import { render, staticRenderFns } from "./addRule.vue?vue&type=template&id=213979c1"
import script from "./addRule.vue?vue&type=script&lang=js"
export * from "./addRule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports